
import { Box, CircularProgress, Typography } from "@mui/material";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function WhatsAppLoader({ status }) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
                gap: 2,
            }}
        >
            <Box sx={{ position: "relative", display: "inline-flex" }}>
                <CircularProgress
                    size={80}
                    thickness={4}
                    color={status ? "success" : "primary"}
                />
                <Box
                    sx={{
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: "absolute",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <WhatsAppIcon id="whatsapp" style={{ fontSize: 40 }} />
                </Box>
            </Box>

            <Typography variant="h5">WhatsApp</Typography>
            <Typography
                variant="body2"
                color="text.secondary"
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
                <WhatsAppIcon id="lock" style={{ fontSize: 16 }} />
                End-to-end encrypted.
            </Typography>
        </Box>
    );
};

